import { useAccount, useReadContract, useReadContracts } from "wagmi";
import useDappConfig from "./useDappConfig";

const useWithdrawals = () => {
  const { address } = useAccount();
  //   const { isEthereumChain, unsupported } = useDappChain();
  const { config, isWithdrawSupported } = useDappConfig();

  const tokensObj = config.tokens;
  const tokens = Object.keys(tokensObj).map((token) => tokensObj[token]);

  const { data: withdrawalDelayBlocks } = useReadContract({
    ...config.interactionPools.lrtWithdrawalManager,
    functionName: "withdrawalDelayBlocks",
    query: {
      enabled: !!address && !!tokens.length && isWithdrawSupported,
    },
  });

  const {
    data: tokensAssociatedNonces,
    refetch: refetchAssociatedNonces,
    isFetching: fetchingAssociatedNonces,
  } = useReadContracts({
    contracts: tokens.map((token) => ({
      ...config.interactionPools.lrtWithdrawalManager,
      functionName: "userAssociatedNonces",
      args: [token.address, address],
    })),
    query: {
      enabled: !!address && !!tokens.length && isWithdrawSupported,
      refetchInterval: 10_000,
    },
  });

  const associatedNoncesPerAsset: { [x: string]: number[] } = tokens.reduce(
    (acc, curr, index) => ({
      ...acc,
      [curr.symbol]: tokensAssociatedNonces
        ? {
            associatedNonces: (
              tokensAssociatedNonces[index].result as bigint[]
            )?.map((val: bigint) => Number(val)) || [0, 0],
            count: Number(
              (tokensAssociatedNonces[index].result as bigint[])[1] -
                (tokensAssociatedNonces[index].result as bigint[])[0]
            ),
          }
        : { associatedNonces: [0, 0], count: 0 },
    }),
    {}
  );

  const tokensWithAssociatedNonces = Object.keys(associatedNoncesPerAsset).map(
    (key) => ({
      ...tokensObj[key],
      ...associatedNoncesPerAsset[key],
    })
  );

  const filteredTokenWithWithdrawals = tokensWithAssociatedNonces.filter(
    (token: any) => token.count
  );

  const contractCallsToFetchWithdrawals = filteredTokenWithWithdrawals
    .map((token: any) => {
      let calls = [];
      const end = token.associatedNonces[1] - token.associatedNonces[0];

      for (let i = 0; i < end; i++) {
        calls.push({
          ...config.interactionPools.lrtWithdrawalManager,
          functionName: "getUserWithdrawalRequest",
          args: [token.address, address, i],
          symbol: token.symbol,
        });
      }

      return calls;
    })
    .flat();

  const { data: userWithdrawalRequests, isFetching: fetchingRequests } =
    useReadContracts({
      contracts: contractCallsToFetchWithdrawals,
      query: {
        enabled:
          !!address &&
          !!filteredTokenWithWithdrawals.length &&
          isWithdrawSupported,
      },
    });

  const userWithdrawals =
    userWithdrawalRequests && withdrawalDelayBlocks
      ? contractCallsToFetchWithdrawals.map((call, index) => ({
          asset: tokensObj[call.symbol].address,
          symbol: call.symbol,
          rsETHAmount: (
            userWithdrawalRequests[index].result as bigint[]
          )[0] as bigint,
          expectedAssetAmount: (
            userWithdrawalRequests[index].result as bigint[]
          )[1] as bigint,
          startTime: Number(
            (userWithdrawalRequests[index].result as bigint[])[2]
          ),
          unlockedOnBlockNumber: Number(
            (userWithdrawalRequests[index].result as bigint[])[2] +
              (withdrawalDelayBlocks as bigint)
          ),
        }))
      : [];

  return {
    userWithdrawals,
    refetchAssociatedNonces,
    isFetching: fetchingAssociatedNonces || fetchingRequests,
  };
};

export default useWithdrawals;
